import React from 'react';

import SectionContainer from '../SectionContainer/SectionContainer';
import AddExternalSection from '../AddExternalSection/AddExternalSection';

import styles from './BrandsSection.module.less';

const BrandsSection = () => {
  return (
    <SectionContainer className={`${styles.sectionColor}`}>
      <div className={styles.container}>
        <div className={styles.brandsSection}>BrandsSection</div>
        <AddExternalSection className={styles.addExternalSection} variant />
      </div>
    </SectionContainer>
  );
};

export default BrandsSection;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/BrandsSection/BrandsSection.jsx